const SERVERS = [
  // Servidores de produção (comentados para usar localhost)
  // process.env.REACT_APP_API_SERVER_1,
  // process.env.REACT_APP_API_SERVER_2,
  
  // Servidor localhost para desenvolvimento
  process.env.REACT_APP_API_SERVER_1 || 'http://localhost:5000',
  process.env.REACT_APP_API_SERVER_2 || 'http://localhost:5000'
];

const EMPRESA = process.env.REACT_APP_EMPRESA || 'dev';

/**
 * Detecta se está rodando em desenvolvimento e ajusta a URL da API
 * para usar o IP da rede quando acessado via IP (ex: celular na rede local)
 */
function adjustServerUrl(server: string): string {
  // Se não for localhost, retorna como está (produção)
  if (!server.includes('localhost') && !server.includes('127.0.0.1')) {
    return server;
  }

  // Se estiver acessando via IP da rede (não localhost), substitui localhost pelo IP
  const currentHost = window.location.hostname;
  const currentPort = window.location.port;
  const currentProtocol = window.location.protocol; // http: ou https:
  
  // Se o hostname atual é um IP (não localhost), substitui na URL da API
  if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
    // Verifica se é um IP válido (formato básico)
    const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (ipPattern.test(currentHost)) {
      // Para APIs locais, mantém o protocolo original (HTTP) mesmo que o frontend esteja em HTTPS
      // Isso evita problemas quando a API não está configurada para HTTPS
      // Extrai o protocolo original da URL da API
      const originalProtocol = server.startsWith('https://') ? 'https' : 'http';
      
      // Substitui localhost/127.0.0.1 pelo IP atual na URL, preservando porta e protocolo original
      // Ex: http://isplaSSAS -> http://192.168.60.4:5000 (mantém HTTP mesmo se frontend estiver em HTTPS)
      const adjusted = server.replace(/(https?:\/\/)(localhost|127\.0\.0\.1)(:\d+)?/g, `${originalProtocol}://${currentHost}$3`);
      return adjusted;
    }
  }

  // Caso contrário, mantém localhost
  return server;
}

export const getBaseUrls = (empresa?: string): string[] => {
  const validServers = SERVERS.filter((server): server is string => Boolean(server));
  
  // Se não houver servidores configurados, retorna array vazio e loga aviso
  if (validServers.length === 0) {
    console.warn(
      '⚠️ Nenhum servidor de API configurado!\n' +
      'Crie um arquivo .env na raiz do projeto com:\n' +
      // 'REACT_APP_API_SERVER_1=https://www.market.net.br/r\n' +
      // 'REACT_APP_API_SERVER_2=https://www.market.srv.br/r\n' +
      'REACT_APP_API_SERVER_1=http://localhost:5000\n' +
      'REACT_APP_API_SERVER_2=http://localhost:5000\n' +
      'REACT_APP_EMPRESA=dev'
    );
    return [];
  }
  
  const currentHost = window.location.hostname;
  return validServers.map(server => {
    // Ajusta a URL para usar IP da rede se necessário
    const adjustedServer = adjustServerUrl(server);
    
    // Se for localhost/IP local, não adiciona /empresa no meio da URL
    if (adjustedServer.includes('localhost') || adjustedServer.includes('127.0.0.1') || /^https?:\/\/(\d{1,3}\.){3}\d{1,3}/.test(adjustedServer)) {
      return adjustedServer;
    }
    // Para produção, mantém o padrão /r/empresa
    return `${adjustedServer}/${empresa || EMPRESA}`;
  });
};

export const API_TIMEOUT =
  parseInt(process.env.REACT_APP_API_TIMEOUT || '10000');
